class Pool<T> {
  private pool: T[]
  private Func: Resettable<T>

  constructor(Func: Resettable<T>) {
    this.pool = []
    this.Func = Func
  }

  get(): T {
    if (this.pool.length) {
      return this.pool.splice(0, 1)[0]
    }
    return new this.Func()
  }

  release(obj: T): void {
    if (this.Func.reset) {
      this.Func.reset(obj)
    }
    this.pool.push(obj)
  }
}

// eslint-disable-next-line @typescript-eslint/ban-types
export interface Resettable<T extends Object> {
  // constructor
  new (): T
  // static
  reset?(obj: T): void
}

export default Pool
